import { useEffect } from 'react'
import { Navigate, useRoutes } from 'react-router-dom'
// layouts
import MainLayout from 'src/layouts/main'
// config
// import { PATH_AFTER_LOGIN } from 'src/config-global'
// api
import { useGetUsers } from 'src/api/user'
import useSupplies from "src/api/hooks/use-supplies"
//
import { mainRoutes, HomePage } from './main';
import { authRoutes } from './auth';
import { dashboardRoutes } from './dashboard';
import { useAuthContext } from '../../auth/hooks';

// ----------------------------------------------------------------------

/**
 * The `Router` method initializes and configures the application's route structure
 * by setting up various routes and user access control for specific functionalities.
 * It uses user access permissions to conditionally initialize resources
 * such as users and supplies.
 *
 * @return {Array} A list of routes configured for the application, including
 * authentication, dashboard, and main routes, along with a fallback 404 route for unmatched paths.
 */
export default function Router() {
  const { user, userDataReady } = useAuthContext()
  const { onInitUsers } = useGetUsers()
  const { onInitSupplies } = useSupplies()

  useEffect(() => {
    // Attendre que les données utilisateur soient complètement chargées
    if (!userDataReady) return;

    const accesses = user?.accesses
    if(accesses?.[0]){
      const userKeys = accesses.find((acc: any) => acc.name === 'user')?.keys
      if(userKeys?.[0]){
        if(userKeys.find((key: any) => key.access?.name === 'list' && key.accessible))
          onInitUsers(user?.id)
      }
      const productKeys = accesses.find((acc: any) => acc.name === 'product')?.keys
      if(productKeys?.[0]){
        if(productKeys.find((key: any) => key.access?.name === 'supply' && key.accessible))
          onInitSupplies({ idUser: user?.id })
      }
    }
  }, [onInitSupplies, onInitUsers, user, userDataReady])

  return useRoutes([
    // SET INDEX PAGE WITH SKIP HOME PAGE
    // {
    //   path: '/',
    //   element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    // },

    // ----------------------------------------------------------------------

    // SET INDEX PAGE WITH HOME PAGE
    {
      path: '/',
      element: (
        <MainLayout>
          <HomePage />
        </MainLayout>
      ),
    },

    // Auth routes
    ...authRoutes,

    // Dashboard routes
    ...dashboardRoutes(user),

    // Main routes
    ...mainRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
